<template>
    <span class="tl-label-tag">
        {{ label }}
    </span>
</template>

<script setup lang="ts">
defineProps<{
    label?: string | number
}>()
</script>

<style lang="sass" scoped>
.tl-label-tag
    @apply bg-secondary text-xs leading-4 font-normal text-secondary-foreground whitespace-nowrap inline-flex items-center
    padding: var(--tl-padding-0-5) var(--tl-padding-1)
    border-radius: var(--tl-radius-sm)
</style>
